// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import "@/assets/css/variables.scss";

// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#6200EE",
    "primary-darken-1": "#3700B3",
    secondary: "#03DAC6",
    "secondary-darken-1": "#018786",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

const myCustomDarkTheme = {
  dark: true,
  colors: {
    background: "#121212",
    surface: "#1E1E1E",
    primary: "#BB86FC",
    "primary-darken-1": "#3700B3",
    secondary: "#03DAC6",
    "secondary-darken-1": "#03DAC6",
    error: "#CF6679",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

export default createVuetify(
  {
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: { mdi },
    },
    theme: {
      defaultTheme: "myCustomLightTheme",
      themes: {
        myCustomLightTheme,
        myCustomDarkTheme
      },
    },
    components,
    directives,
    global: {
      font: {
        family: "Kantumruy Pro,Roboto, sans-serif", // Set your default font family here
      },
    },
    // typography: {
    //   fontFamily: 'Kantumruy Pro,Roboto, sans-serif',

    // },
  }
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
);
